import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import AvatarUser from '../../../assets/avatars/userAvatar.png';

const useStyles = makeStyles({
  commentsContainer: {
    borderTop: '1px solid #A7AAAE',
    paddingTop: 10,
    marginTop: 15,
    display: 'flex',
    alignItems: 'flex-end'
  },

  textField: {
    marginTop: '.5rem',
    width: '100%'
  },
  commentsInput: {
    borderRadius: 10,
    padding: '13.5px 14px',
    marginLeft: 10
  }
});

const NewComment = () => {
  const [comments, setComments] = useState('');
  const classes = useStyles();
  return (
    <div className={classes.commentsContainer}>
      <Avatar className={classes.avatar} src={AvatarUser} />

      <FormControl className={classes.textField} variant="outlined">
        <OutlinedInput
          className={classes.commentsInput}
          id="outlined-adornment-valuation"
          inputProps={{
            'aria-label': 'comments'
          }}
          labelWidth={0}
          multiline
          onChange={(e) => setComments(e.target.value)}
          placeholder="write a comment..."
          rows={1}
          rowsMax={3}
          value={comments}
        />
      </FormControl>
    </div>
  );
};

export default NewComment;
